import React, { useState, useEffect } from "react";
import { EmptyForm } from "../../js/framework/Forms";
import { decodeProcess } from "../../js/framework/Processes";
import GameClient from "../GameClient";
import PlayerWindow from "./PlayerWindow";
import GameClientInit from "../../js/scenario/GameInitialization";

function loadGame() {
	//TODO: move it to GameClient
	var st = JSON.parse(localStorage.getItem("game-save"));
	st.process = decodeProcess(st.process);
	this.state.GM.setState(st);
}

/**
 * GameMainWindow
 * props:
 *	 roles - a list of roles (if any)
 */
export default function GameWindow({ roles }) {
	function finish(state) {
		/* what should we do when game is finished */
	}
	const [ form, setForm ] = useState(EmptyForm);
	// when the component is shown, start the game
	useEffect(() => {
		// configure the game and init client
		GameClientInit(roles, []);
		// player registration
		GameClient.register({
			subj: "Player",
			notify: setForm,
			onFinish: finish
		});
		// starting
		GameClient.start();
	}, [1]);

	return (
		<div className="gamepanel">
			<PlayerWindow form={form} onMove={() => { /* GameClient has already received a move from PlayerWindow, nothing left to do */ }} />
		</div>
	);
}
